export function decodeJWT(token: string) {
  try {
    const [header, payload, signature] = token.split('.');

    // Decode base64url → JSON
    const decodePart = (str) =>
      JSON.parse(atob(str.replace(/-/g, '+').replace(/_/g, '/')));

    return {
      header: decodePart(header),
      payload: decodePart(payload),
      signature: signature, // can't be decoded, only verified
    };
  } catch (err) {
    console.error('Invalid JWT:', err);
    return null;
  }
}

export function isTokenValid(payload: { exp: number }): {
  valid: boolean;
  expiresAt?: string;
  reason?: string;
} {
  try {
    if (!payload.exp) {
      return { valid: false, reason: 'No exp field in token' };
    }

    const now = Math.floor(Date.now() / 1000); // current time in seconds
    const valid = now < payload.exp;

    return {
      valid,
      expiresAt: new Date(payload.exp * 1000).toISOString(),
    };
  } catch (err) {
    return { valid: false, reason: 'Invalid token format' };
  }
}
